/**
 * Helpers for PR preview deployments. Previews are built per-PR and either served statically from
 * S3 under `/react/<pr-tag>/<app>/` or loaded through the regular Django routes with a
 * `?reactTag=<pr-tag>` query param (see .github/actions/deploy). Redirects between apps must carry
 * the tag along, or the user silently falls out of the preview and into the regular build.
 */

/** PR tag (e.g. `pr-123`) when the current page is running a preview build. */
export function getPreviewTag(): string | undefined {
  const pathTag = window.location.pathname.match(/^\/react\/(pr-\d+)\//)?.[1]
  if (pathTag) return pathTag

  const reactTag = new URLSearchParams(window.location.search).get('reactTag')
  return reactTag && /^pr-\d+$/.test(reactTag) ? reactTag : undefined
}

/**
 * URL of the login app, targeting the current PR's preview build when this page is itself a
 * preview. Both routes use the legacy `#/?next=` hash format — the React login router serves the
 * login page at its root, matching what the Django-served route expects.
 */
export function getLoginUrl(nextParam?: string): string {
  const tag = getPreviewTag()
  if (tag) {
    return `/react/${tag}/login/index.html#/${nextParam ? `?next=${nextParam}` : ''}`
  }
  return nextParam ? `/apps/login#/?next=${nextParam}` : '/apps/login'
}
